import React, { Component } from 'react';

//图片
import yunhaoxueyuanzuzhijiagou from './assets/img/yunhaoxueyuanzuzhijiagou.png';
import jiangshijili from './assets/img/jiangshijili.png';


class Section$ extends Component {
    showDrawer = (data) => {
        this.props.enclosureShow(data.target.id,data.target.title)
    }
    render() {
        return (
            <div style={{ textIndent: '2em' }}>

                <div style={{ textAlign: 'center' }}>
                    <br />
                    <h1 name="0-8" className="point" id="0-8">第九章培训管理制度</h1>
                </div>
                <div style={{ textIndent: '2em' }}>
                    <br/>
                    <h2 name="0-8-0" className="point" id="0-8-0">云豪学院组织机构、人事安排及科室作业规范</h2>
                    <h3 name="0-8-0-0" className="point" id="0-8-0-0">一、云豪职业智慧学院组织构架图</h3>
                    <img src={yunhaoxueyuanzuzhijiagou} alt="" style={{ width: '500px', display: 'block', margin: '0 auto' }} />
                    <h3 name="0-8-0-1" className="point" id="0-8-0-1">一、云豪学院组织机构图及管理层人事安排：</h3>
                    <p>1、院长:王云厅</p>
                    <p>2、执行院长：郭莉迪，为云豪学院的第一责权人；对院长汇报工作，接受行政副总裁的监管，服从上级领导的工作安排。</p>
                    <p>3、副院长:高乐（兼），负责与技术培训相关的体系建设，负责技术培训、技术考核与鉴定、技术讲师的管理与培训、厂家和行业培训的接洽；在课表统筹等管理性事务方面服从执行院长的安排。</p>
                    <p>4、统筹专员:于佳宁，参与技术中心、云豪学院的工作，负责全年教程统筹，证书制作、场地管理、培训物资管理、图书馆管理，云豪学院微信公众号的管理等，对执行院长汇报工作，服从上级领导的工作安排。</p>
                    <p>5、培训科 负责人: 郭莉迪(兼)，负责新员工培训、精英训练营、技术培训、职业素养提升课的落地执行，学员考核及等级认证，实时向教研科反馈教学进度。</p>
                    <p>6、教研科 负责人：高乐(兼)， 负责调查培训需求、研发教材和课程，制定讲师成长考核标准。</p>
                    <p>7、统筹科 负责人：于佳宁(兼)，负责职业规划及学习成长档案的建设，负责全年教程统筹，证书制作、场地管理、培训物资管理、图书馆管理，支持培训科、教研科完成各项工作。</p>
                    <h3 name="0-8-0-2" className="point" id="0-8-0-2">三、各科室作业规范</h3>
                    <p>1．培训科作业规范</p>
                    <p>1.1 培训课负责云豪学院所有培训计划的落地执行。</p>
                    <p>1.2 按照统筹科课时安排，准时执行培训计划，保证每节课时长和整体课程的进度；按照教研科对课程的要求授课，不得擅自更改主要内容；确保课程满意率达到90%以上。</p>
                    <p>1.3 按照统筹科的课时安排，举办新员工培训，满意率达到90%以上。</p>
                    <p>1.4 按照统筹科课时安排，每年举办两期精英训练营，每班毕业学员30人以上，满意率90%以上，毕业合格率80%以上。</p>
                    <p>1.5 按照统筹科的课时安排，开展职业素养工具课，满意率不低于90%。</p>
                    <p>1.6 讲师管理，公司副总监（含）以上管理人员、优秀员工、某领域专长人员均可申请加入讲师团，公司将重点培养讲师团成员的综合能力，同时讲师不得擅自退出讲师团。内部讲师无法满足教学需要时，云豪学院可聘请外部讲师。</p>
                    <h4>2. 调研科作业规范</h4>
                    <p>2.1 调研科负责云豪集团培训需求的调查和课程的系统化开发。</p>
                    <p>2.2 培训需求问卷调查</p>
                    <p>需分为年度培训需求问卷调查、阶段性培训需求问卷调查、特定岗位和特定课程的培训需求问卷调查、一对一培训需求问卷调查等，确保问卷调查得到的信息真实有效，具有代表性。</p>
                    <p>2.3根据培训需求，结合《员工手册》、企业发展战略、年度经营指标、行业特性和企业发展阶段，开发系统性的课程，编制培训教材（或PPT），参与课程沙盘演练，直到课程切实符合公司和相关人员的实际需要。</p>
                    <p>2.4为每个课程制定专用的考核体系，包括毕业学员考评规则、考核标准、考题。</p>
                    <h4>3．统筹科工作规范</h4>
                    <p>3.1 统筹科负责制定云豪学院年度培训计划、课时编排、公文写作、培训物资管理、协助培训科执行培训计划、协助调研科完成培训需求调研。</p>
                    <p>3.2 根据教研科编制的教材（或课件）制定系统化的培训计划，合理编排课时，常规课程占可利用课时的60%，随机课程占可利用课时的40%。</p>
                    <p>3.3 对接营销/支持/监管机构的培训需求每三周与人力资源部对接一次新员工入职人数，若新员工入职在10人以上，将安排一次新员工培训，新员工培训需要提前一周通知到培训科和需要参加的人员。</p>
                    <p>3.4 精英训练营开课前三周制定培训方案并发布报名通知。培训方案包括培训目标、培训对象、时间安排、教练和导师安排计划、场外支持、激励方案、资金预算、场地安排等。</p>
                    <p>3.5 根据维修技能培训要求，发布通知，明确参训方式，协助维修技能课程有序开课。</p>
                    <p>3.6 毕业证书的制作，根据培训科考核合格名单，经院长或副院长审核，制作讲师证、毕业证、教练证、工匠证、管理规范等证书。</p>
                    <p>3.7 场地管理，与课程负责人对接，按照课前、课中、课后场地的要求规范管理。</p>
                    <p>3.8 图书馆管理，制作图书及影像资料花名册（包含名称、类型、简介）、借阅管理制度。</p>

                    <h2 name="0-8-1" className="point" id="0-8-1">二、培训资料/档案管理规范</h2>
                    <h3>1. 培训资料、档案的管理规范</h3>
                    <p>1.1 培训资料、档案：包括培训签到表、培训讲义、培训课件、培训考核成绩单、培训评估总结、现场照片、音频资料等。 </p>
                    <p>1.2 培训资料集中保管，详列物资清单，包括资料的数量、规格，分类归档存放。</p>
                    <p>1.3 归档的文件材料字迹清楚、工整，纸张要求为A4纸大小</p>
                    <p>1.4 归档的文件除特殊情况外，必须用原件，对于可输入电脑的资料及时输入电脑，形成电子文档。 </p>
                    <p>1.5 归档的文件材料要完整、系统、准确。</p>
                    <h2 name="0-8-2" className="point" id="0-8-2">三、培训考核及证书颁发标准</h2>
                    <h3 name="0-8-2-0" className="point" id="0-8-2-0">一、云豪集团精英训练营相关证书考核及颁发标准</h3>
                    <p>1、<strong>学员毕业考核</strong>项目有参加课程的出勤情况、考核学员目标达成率、小组会、大组会、教练电话、精英日报、云豪集团企业文化和云豪工作法等，毕业成绩分三个级别：</p>
                    <p>1.1.1 从A级毕业水平的学员中评选六名优秀学员，<strong>颁发A+毕业证书，</strong>获得固定积分130分，在公司今后的加薪、升职时优先考虑；</p>
                    <p>1.1.2 完成全部课程内容，目标达成率80%以上，全部考核达标，获得A级毕业，<strong>颁发A级毕业证书，</strong>获得固定积分100分；</p>
                    <p>1.1.3完成全部课程内容，目标达成率80%以下，小组会、大组会、教练电话累计缺席次数达三次以上，精英日报累计漏发次数达三次以上，企业文化和云豪工作法考核未达标者，<strong>获得B级毕业，</strong>颁发B级毕业证书，无积分奖励。</p>
                    <h4>2、教练毕业考核：</h4>
                    <p>1.2.1 以首周分组后人数为基数，教练所带小组80%以上学员获得A级毕业，教练本人小组会、大组会、教练电话累计缺席次数不超过三次，企业文化和云豪工作法考核达标，该教练获得教练毕业证书，获得固定积分150分。反之，教练获得B级结业证书。</p>
                    <p><strong>教练毕业证书</strong>，获得固定积分150分。反之，<strong>教练获得B级结业证书。</strong></p>
                    <p>1.2.2全体学员80%以上获得A级毕业，教练80%获得毕业证书，总教练方可获得<strong>总教练毕业证书</strong>，获得固定积分180分。反之，<strong>总教练获得B级结业证书。</strong></p>
                    <p>3、毕业后大组会每半年举办一次，学员和教练连续两次不参加大组会的，取消毕业证书。</p>
                    <h3 name="0-8-2-1" className="point" id="0-8-2-1">二、讲师证考核及证书颁发标准</h3>
                    <p>1、参加云豪职业智慧学院讲师培训，并考核合格者，即可获得初级讲师证。</p>
                    <p>2、初级讲师累计授课时长达20小时，可获得中级讲师证。	</p>
                    <p>3、中级讲师累计授课时长达40小时，且综合考评为“优+”级（详见附件1），可获得高级讲师证。</p>
                    <p>4、证书有效期为两年，到期后须参加云豪学院的考核（审验），通过考核后，证书继续有效。</p>
                    <h3 name="0-8-2-2" className="point" id="0-8-2-2">三、工匠证及工具设备操作规范证、维修现场管理证、物资管家证、职业形象证的考核及颁发标准</h3>
                    <p>1、保养工匠证指《员工手册》第八章维保作业切块管理细则内各级保养，由本人提出申请，经云豪职业智慧学院理论及实操培训，考试合格，经工作中实际操作5台次，均符合工艺流程要求，由事业部总监签字确认后，云豪职业智慧学院鉴定并颁发该工匠证书。</p>
                    <p>2、汽车电路工匠证、汽车气路工匠证、故障诊断工匠证、AT/AMT自动变速箱工匠证、汽车钣喷工匠证、发动机大修工匠证、变速箱大修工匠证、底盘大修工匠证，由本人提出申请，经云豪职业智慧学院理论及实操培训，完成设定故障诊断排除考试并考核合格，由事业部总监签字确认后，云豪职业智慧学院鉴定并颁发该工匠证书。</p>
                    <p>3、工具设备操作规范证、维修现场管理证、物资管家证、职业形象证由本人申请，由云豪职业智慧学院理论、实操培训合格，在实际工作中考察一个月，经事业部总监签字确认合格，云豪职业智慧学院鉴定并颁发该证书。</p>
                    <p>4、证书有效期为两年，到期后须参加云豪学院的考核（审验），通过考核后，证书继续有效。</p>
                    <h2 name="0-8-3" className="point" id="0-8-3">四、讲师管理细则</h2>
                    <h3 name="0-8-3-0" className="point" id="0-8-3-0">一、内部讲师的选拔</h3>
                    <p>内部讲师的候选人主要以推荐、自荐、指定为主</p>
                    <p>1、推荐</p>
                    <p>各管理公司/管理中心推荐内部讲师的候选人。推荐人在向云豪学院推荐时，需提供候选人的《云豪集团讲师申请表》。</p>
                    <div><strong style={{ color: '#6699FF' }}>附件：</strong><a href="javascript:void(0);" type="primary" id='Enclosure09' title="《云豪集团讲师申请表》" onClick={(value) => this.showDrawer(value)}>《云豪集团讲师申请表》</a></div>
                    <p>2、自荐</p>
                    <p>云豪集团内部讲师招募长期有效，有意向人员可直接与云豪学院联系，提供个人简历、课件，填写《云豪集团讲师申请表》。</p>
                    <div><strong style={{ color: '#6699FF' }}>附件：</strong><a href="javascript:void(0);" type="primary" id='Enclosure09' title="《云豪集团讲师申请表》" onClick={(value) => this.showDrawer(value)}>《云豪集团讲师申请表》</a></div>
                    <p>3、指定</p>
                    <p>云豪学院依据公司培训规划、具体培训任务及学员要求，向各管理公司/管理中心提出培训讲师需求。</p>
                    <h3 name="0-8-3-1" className="point" id="0-8-3-1">二、外聘讲师的标准</h3>
                    <p>1、原则：当内部讲师资源不能满足培训需求时，可聘请外部讲师。</p>
                    <p>2、讲师来源：厂家、培训机构、咨询公司、同行企业优秀的高级管理、技术、营销人员。</p>
                    <p>3、附：外部讲师聘用流程表</p>
                    <div><strong style={{ color: '#6699FF' }}>附：</strong><a href="javascript:void(0);" type="primary" id='Enclosure91' title="《外部讲师聘用流程表》" onClick={(value) => this.showDrawer(value)}>《外部讲师聘用流程表》</a></div>
                    <br></br>
                    <h3 name="0-8-3-2" className="point" id="0-8-3-2">三、内部讲师的职业素养与纪律要求</h3>
                    <p>1、穿着公司工装，仪表端庄得体，大方自然，精神饱满；</p>
                    <p>2、授课开始前关机或将手机做静音处理；</p>
                    <p>3、培训课件PPT需提前两个工作日发到云豪学院邮箱yunhaoxueyuan@163.com；</p>
                    <p>4、培训当日提前15分钟到达培训地点；</p>
                    <p>5、内部讲师接受云豪学院/需求部门授课任务后，须按时授课，若因特殊原因不能按时授课的，应提前三日通知云豪学院。</p>
                    <p>6、根据培训需求的变化、业务变化，主动改进课程以适应培训需要（同时将调整后的课件提交云豪学院/需求部门）；同时应积极收集、整理、加工、分析工作中与课程相关的案例，作为课程资料的积累。</p>
                    <p>7、PPT简洁明晰，使用云豪集团统一模板。</p>
                    <p>未按照要求执行，以上每项每次考核-100分。</p>
                    <h3 name="0-8-3-3" className="point" id="0-8-3-3">四、讲师的激励：</h3>
                    <p>1、在员工个人发展方面具有优先权，主要表现方面为绩效考核、晋升。</p>
                    <p>2、有可优先参加外派和内部培训。</p>
                    <p>3、为保证培训效果，提高培训质量，内部讲师可向云豪学院申请购置相关书籍、资料、教具等。以上物品由云豪学院或资产部统一购买和管理。</p>
                    <p>4、内部讲师授课津贴</p>
                    <p>注：每个课时以两小时计算。</p>
                    <img src={jiangshijili} alt="" style={{ width: '500px', display: 'block', margin: '0 auto' }} />
                    <p>5、外聘讲师授课课时费：由云豪学院或者培训机构参照市场情况与对方洽谈。</p>
                    <div><strong style={{ color: '#6699FF' }}>附：</strong><a href="javascript:void(0);" type="primary" id='Enclosure92' title="《培训效果评估表》" onClick={(value) => this.showDrawer(value)}>《培训效果评估表》</a></div>
                    <h3 name="0-8-4" className="point" id="0-8-4">五、学员管理细则</h3>
                    <p>1.按时签到，全程参加，不迟到，不早退，不间退，不旷课。</p>
                    <p>2.现场参加培训者，须于开课时间5分钟前完成签到；运用好视通、钉钉、腾讯会议、微信视频等方式参加培训者须于开课时间5分钟前完成视频系统的调试。 </p>
                    <p>3.参加培训时坐姿端正，着装整洁，不做与培训学习无关的事情，不得影响他人学习，不得干扰正常的培训秩序。</p>
                    <p>4.培训现场不抽烟，交头接耳，集中精力投入课程。</p>
                    <p>5.爱护公物，保持培训场地整洁。 </p>
                    <p>6.认真听讲，做好笔记，每次培训结束的当天，均需要按照“成果-体验-学习”的格式写学习总结，发到指定群中。 </p>
                    <p>7. 参加云豪集团精英训练营的学员，需要遵守精英训练营课程范畴，精英训练营保密协议终身有效。</p>
                    <br></br>
                    <h3 name="0-8-5" className="point" id="0-8-5">六、管理中心/公司培训配合细则</h3>
                    <p>1．按照云豪学院培训通知，及时提报参训人员信息，支持参加人员全程参加，提前做好工作安排，不得随意以影响经营生产为理由要求参训学员中途退出培训。</p>
                    <p>2.营销机构由专人负责统计生产过程中软性故障、疑难杂症、高频次返工故障、前沿技术难点等，每两周汇总一次，并提报至云豪学院统筹科，包含故障现象、排查过程、换件明细、车型、机型、箱型等文字及影像资料。</p>
                    <p>3.由云豪学院培训并考核合格的人员，由其本人所在事业部实地工作考察，事业部总监应鼓励支持学员拿到相应证书并将工作表现如实反馈至云豪职业智慧学院，作为颁发或取消相关证书的依据。</p>
            
                </div>
            </div>
        )
    }
}

export default Section$;